/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_SERVER } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {reactLocalStorage} from 'reactjs-localstorage';
import {decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

import {random_character} from '../../functions'

const Screen = ({loading, error}) => {

    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [folder, set_folder] = useState(null);
    const [files, set_files] = useState(null);
    const [overlay, set_overlay] = useState('')
    const [dropdown, set_dropdown] = useState('')
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/

    const _backup = () => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('backup__________', {
            action: 'backup',
		}).then((response) => {
            if(response.data.result == 'success'){
                // console.log('value insert', JSON.stringify(response.data.data, undefined, 2))
                set_refresh(random_character(16))
                error(response.data.title)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_folder = () => {

		loading(true);

		API_GET_REQUEST('backup/read__________?action=folder'
			// + '&bamboo=' + bambooParams
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                // console.log(JSON.stringify(response.data, undefined, 2))
                set_folder(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _read_files = (folder) => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_REQUEST('backup/read__________?action=files'
			+ '&folder=' + folder
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                // console.log(JSON.stringify(response.data, undefined, 2))
                set_overlay(folder)
                set_files(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _delete = (folder, files) => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_REQUEST('backup/read__________?action=delete'
			+ '&folder=' + folder
            + '&files=' + files
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                // console.log(JSON.stringify(response.data, undefined, 2))
                _read_files(folder)
                error(response.data.title)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _download = (folder, files) => {

        console.log(folder + '/' + files)

        if(loading === true){
            return
        }

		loading(true);

		API_GET_REQUEST('backup/download__________?action=files'
			+ '&folder=' + folder
            + '&files=' + files
        , 
		).then((response) => {
            if(response.data.result === 'success'){

                window.open(API_SERVER + '/' + response.data.data)

                // _tmp(folder, files)
            
            }else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}
    
    const _tmp = (folder, files) => {

        console.log(folder + '/' + files)

        if(loading === true){
            return
        }

		loading(true);

		API_GET_REQUEST('backup/download__________?action=tmp'
			+ '&folder=' + folder
            + '&files=' + files
        , 
		).then((response) => {
            if(response.data.result === 'success'){
                console.log('tmp remove')
            }else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        _read_folder()

    }, [refresh])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        <>
            <div>
                <div className="_row _center_align">
                    <div className="_column">
                        <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Backup</h1>
                    </div>
                </div>
                <div className="_row _center_align">
                    <div className="_column">
                        <div className="_row _center_align">
                            <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                            <p className="_push_l_m">Silahkan login vesta untuk backup semua source data, dari database, file, gambar dan system</p>
                        </div>
                    </div>
                    <div onClick={() => _backup()} className="_btn _push_l_m _cursor_pointer">
                        Backup
                    </div>
                </div>
                <div className="_row_auto" style={{marginTop: 30}}>
                    {
                        folder && folder.length > 0 &&
                        folder.map((item, index) => {
                            if(item !== 'tmp'){
                                return(
                                    <div key={index} onClick={() => _read_files(item)} className="_hover_backup">
                                        <div style={{display: 'inline-block', textAlign: 'center'}}>
                                            <ion-icon name="albums-outline" style={{fontSize: 100}}></ion-icon>
                                            <p className="_center_text">{item}</p>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
                {
                    overlay.length > 0 &&
                    <div style={{backgroundColor: '#fff', position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, overflowY: 'auto', overflowX: 'hidden', padding: 20}}>
                        <div className="_row _center_align">
                            <div className="_column">
                                <div className="_row _center_align">
                                    <ion-icon name="file-tray-stacked-outline" style={{fontSize: 20, marginTop: -3}}></ion-icon>
                                    <p className="_push_l_m">{overlay}</p>
                                </div>
                            </div>
                            <div onClick={() => {
                                set_overlay('')
                            }} className="_btn _cursor_pointer">
                                Keluar
                            </div>
                        </div>
                        <div style={{marginTop: 20, marginBottom: 20, marginLeft: -20, marginRight: -22}}>
                            <div style={{borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid'}}></div>
                            {
                                files && files.length > 0 &&
                                files.map((item, index) => (
                                    <>
                                        <div key={index} className="_row _center_align _hover_backup_block">
                                            <div className="_push_r_m">
                                                <ion-icon name="document-outline" style={{fontSize: 18}}></ion-icon>
                                            </div>
                                            <div className="_column _push_r_s">
                                                <p className="_text_overflow">{item}</p>
                                            </div>
                                            {
                                                item !== 'database.dump' ?
                                                    <>
                                                        <div onClick={() => _delete(overlay, item)} key={index} style={{marginRight: 16}}>
                                                            <ion-icon name="trash-outline" style={{fontSize: 18}}></ion-icon>
                                                        </div>
                                                        <div onClick={() => _download(overlay, item)}>
                                                            <ion-icon name="cloud-download-outline" style={{fontSize: 18}}></ion-icon>
                                                        </div>
                                                    </>
                                                :
                                                    null
                                            }
                                        </div>
                                    </>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>
        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;